<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-4 col-lg-3 col-xl-2">
        {{ $t("components.claims_history.header.total_paid") }}
        <br />
        <span class="minfo">
          {{ formatCurrency(employer.TotalPaid) }}
        </span>
      </div>
      <div class="col-12 col-md-4 col-lg-3 col-xl-2">
        {{ $t("views.balanceview.total_due") }}
        <br />
        <span class="minfo">
          {{ formatCurrency(employer.TotalDue) }}
        </span>
      </div>
      <div class="col-12 col-md-4 col-lg-3 col-xl-2">
        {{ $t("views.balancepayments.balance") }}
        <br />
        <span class="minfo">
          {{ formatCurrency(employer.Balance) }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <pbas-data-table
          ref="table"
          :dataProvider="provider"
          identifier="contributionsTerms"
          @error="setDummyTerms"
          :showSelect="false"
          :rowActions="rowActions"
        ></pbas-data-table>
        <error-handler :error="error"></error-handler>
        <v-dialog scrollable v-model="dialogs.view" persistent max-width="1200">
          <employer-term-view
            :term="term"
            :employer="employer"
            @close="dialogs.view = false"
          />
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import { locker } from "../../mixins/locker";
import { planSetter } from "../../mixins/planSetter";
import EmployerTermHeaders from "../../headers/PlanTerms";
import EmployerTermView from "./EmployerTermView.vue";

export default {
  name: "employer-balance-table",
  components: {
    ErrorHandler,
    EmployerTermView,
  },
  mixins: [locker, planSetter],
  props: ["employer"],
  data() {
    return {
      // firstRun:true,
      show: true,
      error: null,
      provider: undefined,
      headers: EmployerTermHeaders,
      term: null,
      rowActions: [
        {
          name: "view",
          icon: "visibility",
          title: "components.membersmanagementtable.details",
          handler: (item) => {
            this.term = JSON.parse(JSON.stringify(item));
            this.dialogs.view = true;
          },
        },
      ],
      dialogs: {
        view: false,
      },
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
    }),
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planColumnsOptions: "planOptions",
      planIdentity: "planIdentity",
    }),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.provider = undefined;
        if (this.employer !== null && this.employer !== undefined) {
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
    },
    employer: {
      handler() {
        this.provider = undefined;
        if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
    },
  },
  mounted() {
    if (
      this.selectedPlan !== null &&
      this.selectedPlan !== undefined &&
      this.employer !== null &&
      this.employer !== undefined
    ) {
      this.loadPlanData();
    }
  },
  methods: {
    formatCurrency(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    setDummyTerms() {
      this.$refs.table.fetchResult = {
        items: [
          {
            Id: "78f90027-7bde-4ca3-aa9e-ae226d74864b",
            Translations: [
              {
                LanguageCode: "en",
                Name: "english name",
              },
              {
                LanguageCode: "fr",
                Name: "french name",
              },
            ],
            Name: "english name",
            StartDate: "2021-10-01T00:00:00.000Z",
            EndDate: "2021-11-01T00:00:00.000Z",
            Paid: 123.45,
            Due: 234.56,
            Balance: 111.11,
          },
        ],
        count: 1,
      };
      this.$refs.table.loading = false;
    },
    async loadPlanData() {
      const url = `plans/${this.selectedPlan.Id}/employers-terms/${
        this.employer.Id
      }`;
      this.provider = new ODataProvider(this.$axiosHttp, url, this.headers);
      // if (this.firstRun) {
      //     this.firstRun = false;
      //   } else {
      //     this.$refs.table.getDataAsync();
      //   }
    },
  },
};
</script>
